import checkbox from '../../fc/checkbox'
import frame from '../../fc/frame'
import radio from '../../fc/radio'
import select from '../../fc/select'
import tree from '../../fc/tree'
import upload from '../../fc/upload'
import group from '../../fc/group'
import subForm from '../../fc/subform'
import IconWarning from './icon/IconWarning.vue'

export default [
  checkbox,
  frame,
  radio,
  select,
  tree,
  upload,
  group,
  subForm,
  IconWarning,
]
